import { ApiUserData } from "../../../models/user/ApiUserData"

export type ProfileFormModel = Omit<ApiUserData, "accept_tieup_status"> & {
  accept_tieup_status: "0" | "1" | "2"
}

export const makeFormModel = (v: ApiUserData): ProfileFormModel => {
  const accept_tieup_status = v.accept_tieup_status.toString() as
    | "0"
    | "1"
    | "2"

  return {
    ...v,
    accept_tieup_status,
  }
}

export const makeApiUserData = (v: ProfileFormModel): Partial<ApiUserData> => {
  if (v.accept_tieup_status === undefined) {
    return {
      ...v,
      accept_tieup_status: undefined,
    }
  }

  const accept_tieup_status = parseInt(v.accept_tieup_status.toString()) as
    | 0
    | 1
    | 2

  return {
    ...v,
    accept_tieup_status,
  }
}
